import { PeerMessage, PeerMessageType } from '@playcastdotio/Messaging';
import { playerConnectionState } from '../../../stores/playerStores';
import { handleIncomingPeerMessage } from '../../peer';
import { joinState } from '../../../stores/globalStores';

export const handlePeerMessage = (message: PeerMessage) => {
  switch (message.type) {
    case PeerMessageType.PEER_GET_ID_ANSWER: {
      playerConnectionState.updateState({
        ...playerConnectionState.currentState,
        playerPeerId: message.peerId,
        peerToken: message.peerToken,
        iceServers: message.iceServers || undefined,
      });
      break;
    }
    case PeerMessageType.PEER_ICE_CANDIDATE:
    case PeerMessageType.PEER_SDP_ANSWER:
    case PeerMessageType.PEER_SDP_OFFER:
    case PeerMessageType.PEER_TUNING_CONTROL: {
      handleIncomingPeerMessage(message);
      break;
    }
    case PeerMessageType.PEER_ERROR: {
      console.error('Peer error', message);
      if (joinState.currentState.state === 'connecting') {
        joinState.updateState({
          ...joinState.currentState,
          state: 'error',
        });
      }
      break;
    }
  }
};
